import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-connectors-settings',
  templateUrl: './connectors-settings.component.html',
  styleUrls: ['./connectors-settings.component.scss']
})
export class ConnectorsSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
